const Services = () => {
  const services = [
    {
      icon: 'ri-user-heart-line',
      title: 'Individualized Support',
      description: 'Personalized care plans designed around each individual\'s unique strengths, needs, and goals for maximum independence.',
      benefits: ['Custom care planning', 'Goal-oriented approach', 'Regular progress reviews']
    },
    {
      icon: 'ri-mental-health-line',
      title: 'Behavioral Support',
      description: 'Evidence-based behavioral interventions and therapeutic strategies to address challenges and promote positive outcomes.',
      benefits: ['Positive behavior support', 'Crisis intervention', 'Family collaboration']
    },
    {
      icon: 'ri-briefcase-4-line',
      title: 'Job Skills Training',
      description: 'Comprehensive vocational preparation including workplace readiness, job-specific skills, and ongoing employment support.',
      benefits: ['Hands-on training', 'Job placement assistance', 'Employer partnerships']
    },
    {
      icon: 'ri-team-line',
      title: 'Social Skills Development',
      description: 'Interactive programs focused on building communication abilities, interpersonal relationships, and community connections.',
      benefits: ['Group activities', 'Communication training', 'Peer interaction']
    },
    {
      icon: 'ri-home-heart-line',
      title: 'Daily Living Skills',
      description: 'Practical training in essential life skills including personal care, household management, and money handling.',
      benefits: ['Self-care training', 'Financial literacy', 'Home management']
    },
    {
      icon: 'ri-community-line',
      title: 'Community Integration',
      description: 'Supported participation in community activities, recreational programs, and social events to foster belonging.',
      benefits: ['Community outings', 'Recreation programs', 'Social events']
    }
  ];

  return (
    <section className="py-28 px-4 bg-teal-500">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-white font-semibold text-sm uppercase tracking-wider bg-white/20 px-5 py-2 rounded-full">What We Offer</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">Our Services</h2>
          <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
            Comprehensive support services designed to help individuals achieve their full potential
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
          {services.map((service, index) => (
            <div 
              key={index} 
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 cursor-pointer"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl mb-6 group-hover:scale-110 transition-transform shadow-lg">
                <i className={`${service.icon} text-white text-3xl`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {service.title}
              </h3>
              
              <p className="text-gray-600 leading-relaxed mb-6">
                {service.description}
              </p>

              <div className="space-y-2 pt-4 border-t border-gray-100">
                {service.benefits.map((benefit, idx) => (
                  <div key={idx} className="flex items-center gap-2 text-sm text-gray-700">
                    <div className="w-5 h-5 flex items-center justify-center bg-teal-100 rounded-full flex-shrink-0">
                      <i className="ri-check-line text-teal-600 text-xs"></i>
                    </div>
                    <span>{benefit}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="bg-white rounded-3xl p-12 text-center shadow-2xl">
          <h3 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">Ready to Get Started?</h3>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto leading-relaxed">
            Contact us today to learn more about our services and how we can support you or your loved ones
          </p>
          <a 
            href="#contact" 
            className="inline-flex items-center gap-2 bg-teal-600 text-white px-10 py-5 rounded-lg hover:bg-teal-700 transition-all font-semibold text-lg shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
          >
            Contact Us Today
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;
